import { createTripArrayFieldMachine } from './createTripArrayFieldMachine';

export const pickupDateTimeMachine = createTripArrayFieldMachine('pickupDateTime');
